// `deleted` implies `expired`, so it has to win to avoid blaming the retention period.
export const getDeleteRunLogsTooltip = ({
  logsDeleted,
  logsExpired,
}: {
  logsDeleted: boolean;
  logsExpired: boolean;
}) => {
  if (logsDeleted) {
    return "These logs were already deleted by an administrator.";
  }

  if (logsExpired) {
    return "These logs have already expired. Our standard retention period is 60 days.";
  }

  return null;
};
